import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { URL_CONSTANTS_TOKEN } from '../../services/url.constant';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  private readonly MODULE_NAME = 'ADMIN';
  private readonly MODULE_NAME1 = 'FRONTEND';
  constructor(@Inject(URL_CONSTANTS_TOKEN) private urlConstants,
    private apiService: ApiService,
  ) { }

  createSuperAdmin(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.CREATE_SUPER_ADMIN,
      body,
    );
  }
  loginSuperAdmin(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.ADMIN_LOGIN,
      body,
    );
  }
  superAdminProfileUpdate(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.PROFILE_UPDATE,
      body,
    );
  }
  superAdminChangePassword(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.CHANGE_PASSWORD,
      body,
    );
  }
  viewSuperAdminDetails(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ADMIN_DETAILS,
      body,
    );
  }

  addCountry(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.ADD_COUNTRY,
      body,
    );
  }
  getAllCountries(): Observable<any> {
    return this.apiService.get<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_COUNTRIES,
    );
  }
  viewSingleCountry(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_SINGLE_COUNTRY,
      body,
    );
  }
  updateCountry(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.UPDATE_COUNTRY,
      body,
    );
  }
  deleteCountry(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.DELETE_COUNTRY,
      body,
    );
  }
  updateCountryStatus(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.UPDATE_COUNTRY_STATUS,
      body,
    );
  }

  addState(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.ADD_STATE,
      body,
    );
  }
  getAllStates(): Observable<any> {
    return this.apiService.get<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_STATES,
    );
  }
  viewSingleState(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_SINGLE_STATE,
      body,
    );
  }
  updateState(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.UPDATE_STATE,
      body,
    );
  }
  deleteState(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.DELETE_STATE,
      body,
    );
  }
  updateStateStatus(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.UPDATE_STATE_STATUS,
      body,
    );
  }

  addCity(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.ADD_CITY,
      body,
    );
  }
  getAllCities(): Observable<any> {
    return this.apiService.get<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_CITIES,
    );
  }
  viewSingleCity(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_SINGLE_CITY,
      body,
    );
  }
  updateCity(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.UPDATE_CITY,
      body,
    );
  }
  deleteCity(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.DELETE_CITY,
      body,
    );
  }
  updateCityStatus(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.UPDATE_CITY_STATUS,
      body,
    );
  }

  addCompanyType(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.ADD_COMPANY_TYPE,
      body,
    );
  }
  updateCompanyType(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.UPDATE_COMPANY_TYPE,
      body,
    );
  }
  viewSingleCompanyType(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_SINGLE_COMAPNY_TYPE,
      body,
    );
  }
  viewAllCompanyTypes(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_COMPANY_TYPES,
      body,
    );
  }
  deleteCompanyType(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.DELETE_COMPANY_TYPE,
      body,
    );
  }

  addEntityEnding(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.ADD_ENTITY_ENDING,
      body,
    );
  }
  updateEntityEnding(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.UPDATE_ENTITY_ENDING,
      body,
    );
  }
  viewSingleEntityEnding(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_SINGLE_ENTITY_ENDING,
      body,
    );
  }
  viewAllEntityEnding(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_ENTITY_ENDING,
      body,
    );
  }
  deleteEntityEnding(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.DELETE_ENTITY_ENDING,
      body,
    );
  }

  addIndustry(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.ADD_INDUSTRY,
      body,
    );
  }
  updateIndustry(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.UPDATE_INDUSTRY,
      body,
    );
  }
  viewSingleIndustry(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_SINGLE_INDUSTRY,
      body,
    );
  }
  viewAllIndustries(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_INDUSTRIES,
      body,
    );
  }
  deleteIndustry(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.DELETE_INDUSTRY,
      body,
    );
  }

  addProjectInfo(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.ADD_PROJECT_INFO,
      body,
    );
  }
  updateProjectInfo(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.UPDATE_PROJECT_INFO,
      body,
    );
  }
  viewSingleProjectInfo(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_SINGLE_PROJECT_INFO,
      body,
    );
  }
  viewAllProjectInfos(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_POJECT_INFO,
      body,
    );
  }
  deleteProjectInfo(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.DLETE_PROJECT_INFO,
      body,
    );
  }

  addCategory(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.ADD_CATEGORY,
      body,
    );
  }
  updateCategory(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.UPDATE_CATEGORY,
      body,
    );
  }
  viewSingleCategory(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_SINGLE_CATEGORY,
      body,
    );
  }
  viewAllCategories(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_CATEGORIES,
      body,
    );
  }
  deleteCategory(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.DELETE_CATEGORY,
      body,
    );
  }

  addFaqs(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.ADD_FAQS,
      body,
    );
  }
  updateFaqs(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.UPDATE_FAQS,
      body,
    );
  }
  viewSingleFaqs(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_SINGLE_FAQS,
      body,
    );
  }
  viewAllFaqs(): Observable<any> {
    const body = [];
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_FAQS,
      body,
    );
  }
  deleteFaqs(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.DLEETE_FAQS,
      body,
    );
  }

  addQuestionandAnswer(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.ADD_QUESTION_AND_ANSWER,
      body,
    );
  }
  updateQuestionandAnswer(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.UPDATE_QUESTION_AND_ANSWER,
      body,
    );
  }
  viewSingleQuestionandAnswer(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_SINGLE_QUESTION_AND_ANSWER,
      body,
    );
  }
  viewAllQuestionandAnswers(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_QUESTION_AND_ANSWERS,
      body,
    );
  }
  deleteQuestionandAnswer(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.DELETE_QUESTION_AND_ANSWER,
      body,
    );
  }

  addTestimonial(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.ADD_TESTIMONIAL,
      body,
    );
  }
  updateTestimonial(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.EDIT_TESTIMONIAL,
      body,
    );
  }
  viewSingleTestimonial(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_SINGLE_TESTIMONIAL,
      body,
    );
  }
  viewAllTestimonials(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_TESTIMONIALS,
      body,
    );
  }
  deleteTestimonial(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.DELETE_TESTIMONIAL,
      body,
    );
  }

  addBlog(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.ADD_BLOG,
      body,
    );
  }
  updateBlog(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.EDIT_BLOG,
      body,
    );
  }
  viewSingleBlog(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_SINGLE_BLOG,
      body,
    );
  }
  viewAllBlogs(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_BLOGS,
      body,
    );
  }
  deleteBlog(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.DELETE_BLOG,
      body,
    );
  }

  adCms(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.ADD_CMS,
      body,
    );
  }
  updateCms(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.EDIT_CMS,
      body,
    );
  }
  viewSingleCms(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_SINGLE_CMS,
      body,
    );
  }
  viewAllCms(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_CMS,
      body,
    );
  }
  deleteCms(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.DELETE_CMS,
      body,
    );
  }

  addStartup(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.ADD_STARTUP,
      body,
    );
  }
  updateStartup(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.EDIT_STARTUP,
      body,
    );
  }
  viewSingleStartup(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_SINGLE_STARTUP,
      body,
    );
  }
  viewAllStartups(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_STARTUPS,
      body,
    );
  }
  deleteStartup(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.DELETE_STARTUP,
      body,
    );
  }
  addOurServices(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.ADD_OUR_SERVICES,
      body,
    );
  }
  updateOurServices(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.UPDATE_OUR_SERVICES,
      body,
    );
  }
  singleViewOurServices(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.SINGLE_VIEW_OUR_SERVICES,
      body,
    );
  }
  viewSingleOurService(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME1,
      this.urlConstants.FRONTEND.VIEW_SINGLE_FRONT_END_OURSERVICE,
      body,
    );
  }
  viewAllOurServices(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_OUR_SERVICES,
      body,
    );
  }
  deleteOurServices(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.DELETE_OUR_SERVICES,
      body,
    );
  }

  // VIEW_US_ADDRESS:'view_us_address'

  viewUsAddress(): Observable<any> {
    return this.apiService.get<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_US_ADDRESS,
    );
  }

  updateUsAddress(body): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.UPDATE_US_ADDRESS,
      body,
    );
  }

  addCompanyState(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.ADD_COMPANY_STATES,
      body,
    );
  }
  updateCompanyState(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.EDIT_COMPANY_STATES,
      body,
    );
  }
  singleViewCompanyState(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_COMPANY_STATE,
      body,
    );
  }
  viewAllCompanyStates(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_COMPANY_STATES,
      body,
    );
  }
  deleteCompanyState(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.DELETE_COMPANY_STATES,
      body,
    );
  }

  viewAllCompanies(): Observable<any> {
    return this.apiService.get<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_COMPANIES,
    );
  }

  viewAllNewsLetters(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_NEWS_LETTERS,
      body,
    );
  }

  deleteNewsLetter(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.DELETE_NEWS_LETTER,
      body,
    );
  }

  addBuilt(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.ADD_BUILTS,
      body,
    );
  }
  updateBuilt(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.EDIT_BUILTS,
      body,
    );
  }
  singleViewBuilt(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_BUILT,
      body,
    );
  }
  viewAllBuilts(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_BUILTS,
      body,
    );
  }
  deleteBuilt(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.DELETE_BUILTS,
      body,
    );
  }

  addPlan(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.ADD_PLANS,
      body,
    );
  }
  updatePlan(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.EDIT_PLANS,
      body,
    );
  }
  singleViewPlan(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_PLAN,
      body,
    );
  }
  viewAllPlans(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_PLANS,
      body,
    );
  }
  deletePlan(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.DELETE_PLANS,
      body,
    );
  }

  addSocialMedia(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.ADD_SOCIAL_MEDIA,
      body,
    );
  }
  updateSocialMedia(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.EDIT_SOCIAL_MEDIA,
      body,
    );
  }
  singleViewSocialMedia(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_SOCIAL_MEDIA,
      body,
    );
  }
  viewAllSocialMedias(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_SOCIAL_MEDIA,
      body,
    );
  }
  deleteSocialMedia(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.DELETE_SOCIAL_MEDIA,
      body,
    );
  }

  // VIEW_ALL_COUNTS: 'view_all_counts',
  viewAllCounts(): Observable<any> {
    const body = [];
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_COUNTS,
      body,
    );
  }

  getAllAccessCountries(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_ACCESS_COUNTRIES,
      body,
    );
  }

  getAllCustomerList(): Observable<any> {
    return this.apiService.get<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_CUSTOMER_LIST,
    );
  }

  viewSingleCompanyDetails(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.GET_SINGLE_COMPANY,
      body,
    );
  }

  addDocumentType(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.ADD_DOCUMENT_TYPE,
      body,
    );
  }
  updateDocumentType(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.EDIT_DOCUMENT_TYPE,
      body,
    );
  }
  viewSingleDocumentType(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_DOCUMENT_TYPE,
      body,
    );
  }
  viewAllDocumentTypes(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_DOCUMENTS_TYPES,
      body,
    );
  }
  deleteDocumentType(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.DELETE_DOCUMENT_TYPE,
      body,
    );
  }

  addAdminDocument(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.ADD_ADMIN_DOCUMENT,
      body,
    );
  }
  updateAdminDocument(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.EDIT_ADMIN_DOCUMENT,
      body,
    );
  }
  viewSingleAdminDocument(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ADMIN_DOCUMENT,
      body,
    );
  }
  viewAllAdminDocuments(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_ADMIN_DOCUMENTS,
      body,
    );
  }
  deleteAdminDocument(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.DELETE_ADMIN_DOCUMENT,
      body,
    );
  }

  viewContacts(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_CONTACTUS,
      body,
    );
  }
  viewServices(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_OURSERVICES_TRANSACTIONS,
      body,
    );
  }
  viewEnquires(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_ENQUIRES,
      body,
    );
  }
  singkeViewEnquire(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.SINGLE_VIEW_ENQUIRY,
      body,
    );
  }

  addPlanDuration(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.ADD_PLAN_DURAATION,
      body,
    );
  }
  updatePlanDuration(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.EDIT_PLAN_DURATION,
      body,
    );
  }
  viewSinglePlanDuration(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_SINGLE_PLAN_DURATION,
      body,
    );
  }
  viewAllPlanDurations(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_PLAN_DURATIONS,
      body,
    );
  }
  deletePlanDuration(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.DELETE_PLAN_DURATION,
      body,
    );
  }

  addAdminDocuments(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.ADD_ADMIN_DOCUMENTS,
      body,
    );
  }
  acceptRejectDocuments(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.ACCEPT_REJECT_FRONT_END_DOCUMENTS,
      body,
    );
  }
  updateCompany(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.UPDATE_COMPANY,
      body,
    );
  }
  changeCompanyPaymentStatus(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.CHANGE_COMPANY_PAYMENT_STATUS,
      body
    );
  }
  getAvailablePlanDurations(): Observable<any> {
    return this.apiService.get<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.GET_AVAILABLE_PLAN_DURATIONS
    );
  }

  addTaxService(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.ADD_TAX_SERVICE,
      body,
    );
  }
  updateTaxService(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.EDIT_TAX_SERVICE,
      body,
    );
  }
  viewAllTaxServices(): Observable<any> {
    return this.apiService.get<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_TAX_SERVICES
    );
  }
  deleteTaxService(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.DELETE_TAX_SERVICE,
      body,
    );
  }

  activateTaxService(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.ACTIVATE_TAX_SERVICE,
      body,
    );
  }

  deactivateTaxService(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.DEACTIVATE_TAX_SERVICE,
      body,
    );
  }
  viewSingleTaxService(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_SINGLE_TAX_SERVICE,
      body,
    );
  }
  addTaxServiceQuestion(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.ADD_TAX_SERVICE_QUESTION,
      body,
    );
  }
  updateTaxServiceQuestion(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.EDIT_TAX_SERVICE_QUESTION,
      body,
    );
  }
  viewAllTaxServiceQuestions(): Observable<any> {
    return this.apiService.get<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_ALL_TAX_SERVICE_QUESTIONS
    );
  }
  deleteTaxServiceQuestion(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.DELETE_TAX_SERVICE_QUESTION,
      body,
    );
  }

  activateTaxServiceQuestion(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.ACTIVATE_TAX_SERVICE_QUESTION,
      body,
    );
  }

  deactivateTaxServiceQuestion(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.DEACTIVATE_TAX_SERVICE_QUESTION,
      body,
    );
  }
  viewSingleTaxServiceQuestion(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.VIEW_SINGLE_TAX_SERVICE_QUESTION,
      body,
    );
  }
  viewAllTaxResponses(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.GET_TAX_QUESTIONS_RESPONSES,
      body,
    );
  }
  viewSingleTaxResponse(body: any): Observable<any> {
    return this.apiService.post<any>(
      this.MODULE_NAME,
      this.urlConstants.ADMIN.GET_SINGLE_TAX_RESPONSE,
      body,
    );
  }
}
